import React, {useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import {isMobile} from 'react-device-detect';

const CellularPackageData = (props) => {
  return (
    <div className={` ${isMobile ? 'isMobile pr-0 pl-0' : ''} text-center current-package-popup`}>
      <div className='semiBold main-text d-block w-100'>מה בחבילה?</div>
      <div className='w-100 cellular-package-data text-center'>{props.package.pp_details_desc}</div>
    </div>
  );
};

export default CellularPackageData;
